export default {
    groups: [],
    channels: [],
    pinned: []
}